/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { AlbumItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Download } from '../Download/Download';
import { Favorite } from '../Favorite/Favorite';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface AlbumProps extends AlbumItemProps {
    checkboxClassname?: string;
    favoriteClassname?: string;
}

export const Album: FC<AlbumProps> = (props) => {
    const { denyDoAction, checkboxClassname, favoriteClassname } = props;

    return (
        <>
            <TableColumn>
                <Checkbox
                    className={checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                    isDisabled={denyDoAction}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    author={props.author}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} loading={denyDoAction} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {!denyDoAction && (
                    <Favorite
                        className={favoriteClassname}
                        isAvailable={!!props.favoritesAvailable}
                        isFavorite={!!props.isInFavorites}
                        onClick={props.onFavorites}
                    />
                )}
                {!denyDoAction && (
                    <Download
                        onClick={props.onDownload}
                        ext={props.isFolder ? 'zip' : props.ext}
                        size={props.size}
                        id={props.id}
                        storage={props.storage}
                    />
                )}
            </TableColumn>
        </>
    );
};
